import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import Layout from './Layout';
import Achievements from './Achievements';

export default function AchievementsPage() {
  return (
    <Layout>
      {/* Breadcrumb Navigation */}
      <Box sx={{ 
        background: '#1a1a2e',
        padding: '16px 32px',
        borderRadius: '16px',
        marginBottom: '32px',
        border: '1px solid rgba(102, 126, 234, 0.1)',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
      }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            component={RouterLink}
            to="/"
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              color: '#cbd5e1',
              textDecoration: 'none',
              '&:hover': { color: '#667eea' },
            }}
          >
            <HomeIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
            Início
          </Link>
          <Typography 
            color="text.primary" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              fontWeight: 600,
            }}
          >
            <EmojiEventsIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
            Conquistas
          </Typography>
        </Breadcrumbs>
      </Box>

      <Achievements userId="default" />
    </Layout>
  );
}